import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages";
import Blog from "./pages/blog";
import Events from "./pages/events";
import Contact from "./pages/contact";
import BlogPost from "./pages/blogPost";
import Event from "./pages/Event";
import "./App.css";
import "./App_mobile.css";
import Admin from "./pages/Admin";
import AdminEvent from "./admin/AdminEvent";
const queryString = window.location.search.slice(1);

let scroll = 0;
window.addEventListener("scroll", (event) => {
  let previous = scroll + 5;
  scroll = window.scrollY;

  if (scroll > 200) {
    document.getElementById("burger").classList.add("closed");
  }
  if (previous > scroll + 6) {
    document.getElementById("burger").classList.remove("closed");
  }
});
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route routerDirection="none" exact path="/" Component={Home}>
            Hem
          </Route>
          <Route routerDirection="none" path="/Blog/*" Component={Blog}>
            Blog
          </Route>
          <Route routerDirection="none" path="/Events/*" Component={Events}>
            Event
          </Route>
          <Route routerDirection="none" path="/Contact" Component={Contact}>
            Kontakt
          </Route>
          <Route path="/BlogPost" Component={BlogPost}></Route>
          <Route path="/Event" Component={Event}></Route>
          <Route path="/Admin" Component={Admin}></Route>
          <Route path="/Admin/Event" Component={AdminEvent}></Route>
          <Route path="/admin" Component={Admin}></Route>
          <Route path="/admin/Event" Component={AdminEvent}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
